export { default as baseController } from './base.controller';
export { default as checkoutsController } from './checkouts.controller';
export { default as documentsController } from './documents.controller';
export { default as documentsSearchController } from './documents.search.controller';
export { default as favoritesController } from './favorites.controller';
export { default as myDeadLinesController } from './my.dead.lines.controller';
export { default as myExpiredDocController } from './my.expired.doc.controller';
export { default as notificationsController } from './notifications.controller';
export { default as propertiesController } from './properties.controller';
export { default as publicLinksController } from './public.links.controller';
export { default as shareDocumentsController } from './share.documents.controller';
export { default as sharedsController } from './shareds.controller';
export { default as trashCanController } from './trashcan.controller';
export { default as uploadsController } from './uploads.controller';
